import { render, staticRenderFns } from "./LegacyBlogPost.vue?vue&type=template&id=5e73e42a&"
import script from "./LegacyBlogPost.vue?vue&type=script&lang=js&"
export * from "./LegacyBlogPost.vue?vue&type=script&lang=js&"
import style0 from "./LegacyBlogPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports